import styled from 'styled-components';
import {
    Anchor,
    FormHelp,
    Popper,
    TextButton,
} from '@zillow/constellation';

export const StyledFontAnchor = styled(Anchor)`
    font-size: 13px;
`;

export const StyledPopper = styled(Popper)`
    vertical-align: inherit;
`;

export const StyledZestimateFormHelp = styled(FormHelp)`
    position: relative;
    bottom: 10px;
`;

export const StyledTextButton = styled(TextButton)`
    font-size: 12px;
    font-weight: 400;
`;
